import type { RewardsEarningRulesEntity } from "@apps/rewards/modules/EarningRules/models/RewardsEarningRulesEntities";

import type { EarningRulesSdkResultDTO } from "../../types";
import { mapBaseRewardToDTO } from "./mapRewardToDTO";

export const mapEarningRulesToDTO = (
    items: Array<RewardsEarningRulesEntity>
): Array<EarningRulesSdkResultDTO> =>
    items.map((item) => ({
        id: item.id,
        title: item.title,
        description: item.description,
        rewarding: mapBaseRewardToDTO(item.rewarding),
        icon: item.icon,
        completed: item.completed,
        type: item.type,
    }));
